import { gql } from '@apollo/client';

export const GET_LIST_TEAM_ACCESS_GROUP = gql`
  query GetList($where: Map, $sort: Map) {
    GetTeamAccessGroupList(
      pagination: { offset: 0, limit: 100, where: $where, sort: $sort }
    ) {
      ... on PaginationResponse {
        count
      }
      ... on TeamAccessGroups {
        data {
          id
          team_id
          team {
            ... on Team {
              id
              name
              partner
              limit
              start_date
              end_date
              type
              status
              socmed_account_limit
              created_at
              updated_at
              deleted_at
            }
          }
          access_group_id
          access_group {
            ... on AccessGroup {
              id
              slug
              name
              type
              description
              rest
              graphql
              rules {
                ... on PaginationResponse {
                  count
                }
                ... on Rules {
                  data {
                    id
                    name
                    slug
                    type
                    scope
                    created_at
                    updated_at
                    deleted_at
                  }
                }
              }
            }
          }
          created_at
          updated_at
          deleted_at
        }
      }
    }
  }
`;

export const GET_TEAM_ACCESS_GROUP_BY_ID = gql`
  query GetByID($id: String!) {
    list: GetTeamAccessGroupByID(id: $id) {
      id
      team_id
      team {
        ... on Team {
          id
          name
          partner
          limit
          start_date
          end_date
          type
          status
          socmed_account_limit
          created_at
          updated_at
          deleted_at
        }
      }
      access_group_id
      access_group {
        ... on AccessGroup {
          id
          slug
          rest
          graphql
          rules {
            ... on PaginationResponse {
              count
            }
            ... on Rules {
              data {
                id
                name
                slug
                type
                scope
                created_at
                updated_at
                deleted_at
              }
            }
          }
        }
      }
      created_at
      updated_at
      deleted_at
    }
  }
`;
